import { Box } from "@mui/material";

// A sample user object to display data. In a real app, this would come from an API.
export const sampleUser = {
  profilePicture: 'https://placehold.co/100x100/F4C542/FFFFFF?text=JP',
  name: 'John Paul',
  email: 'john.paul@example.com',
  role: 'Trader',
  contact: '+1 234 567 890',
  companyName: 'RecycleTech Inc.',
  tradePreference: ['Plastic', 'Paper', 'Metals'],
  kycVerification: 'Verified',
};

// Data for the KYC documents table.
export const kycDocuments = [
  { srNo: 1, document: 'Passport', type: 'ID Proof', file: 'passport.pdf', status: 'Approved', uploaded: '2023-01-15' },
  { srNo: 2, document: 'Utility Bill', type: 'Address Proof', file: 'bill.jpg', status: 'Pending', uploaded: '2023-01-18' },
  { srNo: 3, document: 'Driving License', type: 'ID Proof', file: 'license.png', status: 'Rejected', uploaded: '2023-01-20' },
  { srNo: 4, document: 'Passport', type: 'ID Proof', file: 'passport.pdf', status: 'Approved', uploaded: '2023-01-15' },
  { srNo: 5, document: 'Utility Bill', type: 'Address Proof', file: 'bill.jpg', status: 'Pending', uploaded: '2023-01-18' },
  { srNo: 6, document: 'Driving License', type: 'ID Proof', file: 'license.png', status: 'Rejected', uploaded: '2023-01-20' },
  { srNo: 7, document: 'Passport', type: 'ID Proof', file: 'passport.pdf', status: 'Approved', uploaded: '2023-01-15' },
  { srNo: 8, document: 'Utility Bill', type: 'Address Proof', file: 'bill.jpg', status: 'Pending', uploaded: '2023-01-18' },
  { srNo: 9, document: 'Driving License', type: 'ID Proof', file: 'license.png', status: 'Rejected', uploaded: '2023-01-20' },
  { srNo: 10, document: 'Passport', type: 'ID Proof', file: 'passport.pdf', status: 'Approved', uploaded: '2023-01-15' },
  { srNo: 11, document: 'Utility Bill', type: 'Address Proof', file: 'bill.jpg', status: 'Pending', uploaded: '2023-01-18' },
  { srNo: 12, document: 'Driving License', type: 'ID Proof', file: 'license.png', status: 'Rejected', uploaded: '2023-01-20' },
];

// TabPanel component to display content for the active tab.
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

export default TabPanel